<template>
  <!-- TODO: Ha nincs megjelenítendő ország akkor is jobb oldalt jelenjen meg a hozzáadás gomb -->
  <div style="height: calc(100vh - 230px)">
    <!--SLIDER ÉS GOMBOK -->
    <div v-show="!isCountriesLoading" style="position: relative; display:flex;">
      <swiper
        v-show=" getCountries.length > 0"
        id="countries"
        :options="swiperOption"
        ref="countriesSwiper"
      >
        <!-- slides -->
        <swiper-slide class="slide" v-for="(country, i) in getCountries" :key="i">
          <!-- Az ország box -->
          <div
            class="country"
            :class="{active: $route.params.country == country.id}"
            @click="setSelectedCountry(country);"
          >{{country.name}}</div>
        </swiper-slide>
      </swiper>
      <!-- Slider melletti gombok navigációs gombok -->
      <div v-show="!isCountriesLoading" id="nav-container">
        <!-- Balra gomb -->
        <div v-if="getCountries.length > 0" @click="swiper.slidePrev()" id="nav-left">
          <img src="@/assets/ntk_nav_left_g.svg">
        </div>

        <!-- Add gomb. Nem szükséges vele foglalkoznod  -->
        <div
          v-if="getCurrentUser"
          @click="selectedCountryObject = {}; isShowAddDialog = true;"
          id="nav-add"
        >
          <img src="@/assets/ntk_nav_add_g.svg">
        </div>

        <!-- Edit gomb. Nem szükséges vele foglalkoznod -->
        <div
          v-if="getCurrentUser && $route.params.country"
          @click="setCountryObject(); isShowAddDialog = true "
          id="nav-edit"
        >
          <img src="@/assets/ntk_nav_edit_g.svg">
        </div>

        <!-- Törlés. Nem szükséges vele foglalkoznod szerintem. -->
        <v-dialog
          v-if="getCurrentUser && $route.params.country"
          v-model="isShowDeleteDialog"
          persistent
          max-width="500px"
          transition="dialog-transition"
        >
          <div slot="activator" @click="setCountryObject()" id="nav-delete">
            <img src="@/assets/ntk_nav_delete_g.svg">
          </div>
          <v-card>
            <v-card-text class="headline">{{`${selectedCountryObject.name} törlése`}}</v-card-text>
            <v-card-text
              class="font-weight-bold"
            >Biztosan törli? (A törlés elfogadásával törlődik az ország, valamint a hozzá tartozó dokumentumok)</v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn :disabled="isLoading" @click="isShowDeleteDialog = false;">Mégse</v-btn>
              <v-btn :loading="isLoading" @click="deleteCountry()">Törlés</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Jobbra gomb -->
        <div v-if="getCountries.length > 0" @click="swiper.slideNext()" id="nav-right">
          <img src="@/assets/ntk_nav_right_g.svg">
        </div>
      </div>
    </div>

    <!--Ezeket itt meg kell oldani hogy ne lógjanak túl 40px el -->
    <!--LOADER-->
    <v-layout v-if="isCountriesLoading" fill-height justify-center align-center row wrap>
      <v-progress-circular indeterminate></v-progress-circular>
    </v-layout>

    <!-- Nincs ország-->
    <v-layout
      v-else-if="$route.params.country == null && getCountries.length == 0 "
      fill-height
      justify-center
      align-center
      row
      wrap
      style="height: calc(100% - 40px);"
    >
      <v-flex xs12>
        <div class="text-xs-center">Az évszámhoz még nem vettek fel országot</div>
      </v-flex>
    </v-layout>

    <!-- Nincs kiválasztva ország -->
    <v-layout
      v-else-if="$route.params.country == null && getCountries.length > 0 "
      class="text-xs-center"
      row
      wrap
      fill-height
      align-center
      justify-center
      style="height: calc(100% - 40px);"
    >
      <v-flex xs12>
        <div>Nincs kiválasztva ország</div>
      </v-flex>
    </v-layout>

    <!-- Country alá tartozó doksik -->
    <countries-document v-else-if="$route.params.country"></countries-document>

    <!-- Felvevő és módosító dialógus ablak (Ezt neked nem kell formáznod mivel nem látja senki) -->
    <v-dialog v-model="isShowAddDialog" persistent max-width="500px" transition="dialog-transition">
      <v-card>
        <v-card-title
          class="headline"
        >{{selectedCountryObject.id ?'Ország módosítása':'Ország felvétele'}}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
                :value="selectedCountryObject.short"
                @input="selectedCountryObject.short = $event"
                v-validate="'required|alpha_num'"
                :error-messages="errors.collect('short')"
                data-vv-name="short"
                label="Ország azonosító"
                hint="Pl: HU"
                class="mb-3 pt-0"
              ></v-text-field>
              <v-text-field
                :value="selectedCountryObject.name"
                @input="selectedCountryObject.name = $event"
                v-validate="'required|alpha_num'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"
                label="Ország megnevezés"
                hint="Pl: Magyarország"
                class="pt-0"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="isShowAddDialog = false;">Mégse</v-btn>
          <v-btn
            :loading="isLoading"
            @click="selectedCountryObject.id ?  editCountry() : addCountry();"
          >Mentés</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import {
  countriesCollection,
  documentsCollection,
  documentInfoCollection,
  db,
  storage
} from "@/firebaseConfig";
import Raven from "raven-js";
import CountriesDocument from "./CountriesDocument.vue";
import CountriesMixin from "../mixins/CountriesMixin";
import DocumentsMixin from "../mixins/DocumentsMixin";
import _ from "lodash";

export default {
  name: "Countries",
  components: {
    CountriesDocument
  },
  mixins: [CountriesMixin, DocumentsMixin],
  data() {
    return {
      isShowDeleteDialog: false,
      isLoading: false,
      isShowAddDialog: false,
      selectedCountryObject: {},
      swiper: {},
      swiperOption: {
        slidesPerView: "auto",
        mousewheel: true,
        resistance: true,
        resistanceRatio: 0
      }
    };
  },
  watch: {
    getCountries: function(val) {
      const countryId = this.$route.params.country;
      const yearId = this.$route.params.year;

      if (countryId == null && this.getCountries.length > 0) {
        this.$router.push({
          path: `/index/${yearId}/${this.getCountries[0].id}`
        });
        this.setCountryObject();
        this.requestDocuments();
      } else if (!_.some(this.getCountries, { id: countryId })) {
        this.$router.push({
          path: `/index/${yearId}`
        });
      } else {
        this.setCountryObject();
        this.slideToActiveSlide();
        this.requestDocuments();
      }
    }
  },
  computed: {
    ...mapGetters([
      "getCurrentUser",
      "getCountries",
      "isCountriesLoading",
      "isDocumentsLoading"
    ])
  },
  methods: {
    setSelectedCountry(country) {
      const countryId = this.$route.params.country;
      const yearId = this.$route.params.year;
      if (countryId != country.id) {
        this.$router.push({
          path: `/index/${yearId}/${country.id}`
        });
        this.setCountryObject();
        this.requestDocuments();
      } else {
        this.$router.push({
          path: `/index/${yearId}`
        });
      }
    },
    setCountryObject() {
      const countryId = this.$route.params.country;
      this.selectedCountryObject = _.cloneDeep(
        _.find(this.getCountries, country => {
          return country.id == countryId;
        })
      );
    },
    addCountry() {
      const countryId = this.$route.params.country;
      const yearId = this.$route.params.year;

      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.isLoading = true;
          countriesCollection
            .where("short", "==", this.selectedCountryObject.short)
            .where("year", "==", yearId)
            .get()
            .then(docSnapshot => {
              if (!docSnapshot.empty) {
                return Promise.reject(
                  "Az ország azonosítójának egyedinek kell lennie!"
                );
              } else {
                return countriesCollection.add({
                  name: this.selectedCountryObject.name,
                  short: this.selectedCountryObject.short,
                  year: yearId
                });
              }
            })
            .then(data => {
              this.selectedCountryObject.id = data.id;
              this.requestCountries();
              this.routeToSelectedCountry();
              this.isShowAddDialog = false;
            })
            .catch(err => {
              Raven.captureException(err);

              this.$notify({
                group: "app",
                text: `Hiba az országok betöltése közben`,
                type: "error "
              });
            })
            .finally(() => {
              this.isLoading = false;
            });
        }
      });
    },
    editCountry() {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.isLoading = true;
          countriesCollection
            .doc(this.selectedCountryObject.id)
            .update({
              name: this.selectedCountryObject.name,
              short: this.selectedCountryObject.short
            })
            .then(data => {
              this.requestCountries();
              this.isShowAddDialog = false;
            })
            .catch(err => {
              Raven.captureException(err);

              this.$notify({
                group: "app",
                text: `Hiba a módosítás közben:  ${err.message}`,
                type: "error "
              });
            })
            .finally(() => {
              this.isLoading = false;
            });
        }
      });
    },
    async deleteImages(imageIds) {
      for (const imageId of imageIds) {
        await storage
          .child(`documents/${imageId}`)
          .delete()
          .catch(err => {
            return Promise.reject(err);
          });
      }
      return Promise.resolve();
    },
    async deleteDocuments(imageIds, batch, documentId) {
      for (const imageId of imageIds) {
        await documentInfoCollection
          .where("document_id", "==", documentId)
          .where("page_uid", "==", Number(imageId))
          .get()
          .then(querySnapshot => {
            if (!querySnapshot.empty) {
              batch.delete(
                documentInfoCollection.doc(querySnapshot.docs[0].id)
              );
            }
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }
      return Promise.resolve();
    },
    deleteCountry() {
      const documentId = this.$route.query.document;
      const pageId = this.$route.query.page;

      this.isLoading = true;
      var batch = db.batch();

      let imageIds = [];

      batch.delete(countriesCollection.doc(this.selectedCountryObject.id));

      documentsCollection
        .where("country_id", "==", this.selectedCountryObject.id)
        .get()
        .then(querySnapshot => {
          querySnapshot.docs.forEach(documentObject => {
            imageIds = [
              ...imageIds,
              ..._.map(documentObject.data().pages, page => {
                return page.uid;
              })
            ];
            batch.delete(documentsCollection.doc(documentObject.id));
          });

          return this.deleteDocuments(imageIds, batch, documentId);
        })
        .then(querySnapshot => {
          if (querySnapshot && !querySnapshot.empty) {
            batch.delete(documentInfoCollection.doc(querySnapshot.docs[0].id));
          }
          return this.deleteImages(imageIds);
        })
        .then(() => {
          return batch.commit();
        })
        .then(() => {
          this.selectedCountryObject = {};
          this.requestCountries();
        })
        .catch(err => {
          Raven.captureException(err);

          this.$notify({
            group: "app",
            text: `Sikertelen törlés:  ${err.message}`,
            type: "error "
          });
        })
        .finally(() => {
          this.isShowDeleteDialog = false;
          this.isLoading = false;
        });
    },
    routeToSelectedCountry() {
      this.$router.push({
        path: `/index/${this.$route.params.year}/${
          this.selectedCountryObject.id
        }`
      });
    },
    slideToActiveSlide() {
      const countryId = this.$route.params.country;
      if (countryId) {
        this.swiper.slideTo(
          _.findIndex(this.getCountries, country => {
            return country.id == this.$route.params.country;
          }) - 1
        );
      }
    }
  },
  mounted() {
    this.swiper = this.$refs.countriesSwiper.swiper;
  }
};
</script>

<style>
#countries {
  width: 100%;
  height: auto;
  font-weight: 500;
  user-select: none;
}

.swiper-slide {
  width: auto;
}

.country,
#img-tab,
#txt-tab {
  display: inline-block;
  float: left;
  border-width: 0 1px 0 0;
  border-style: solid;
  border-color: #a5a5a5;
  padding: 10px 15px;
  width: auto;
  height: 100%;
  background-color: #eaeaea;
  cursor: pointer;
  transition: background-color 200ms ease-in-out;
}

@media (hover: hover) {
  .country:hover,
  #img-tab:hover,
  #txt-tab:hover {
    color: #323639;
    background-color: #a5a5a5;
  }
}

@media (hover: none) {
  .country:hover,
  #img-tab:hover,
  #txt-tab:hover {
    color: #ffffff;
    background-color: #323639;
  }
}

#img-tab,
#txt-tab {
  border-style: solid;
  border-color: #a5a5a5;
  width: 50%;
  text-align: center;
  font-weight: 500;
}

#img-tab {
  border-width: 1px 1px 0 0;
}

#txt-tab {
  border-width: 1px 0 0 0;
}

.active {
  color: #ffffff !important;
  background-color: #323639 !important;
}

#nav-container {
  display: flex;
  position: relative;
  right: 0;
  border-width: 0 0 0 1px;
  border-style: solid;
  border-color: #a5a5a5;
  height: 40px;
}

#nav-left,
#nav-edit,
#nav-add,
#nav-delete,
#nav-right {
  width: 40px;
  height: 40px;
  background-color: #eaeaea;
  cursor: pointer;
  transition: background-color 200ms ease-in-out;
}

#nav-left:hover,
#nav-edit:hover,
#nav-add:hover,
#nav-delete:hover,
#nav-right:hover {
  background-color: #a5a5a5;
}

.swiper-pagination-bullet {
  width: 10px;
  height: 10px;
  margin: 10px 0 !important;
}

.swiper-pagination-bullet-active {
  background-color: rgb(255, 255, 255);
}
</style>

